import {
  Button,
  MODAL_SIZE_SM,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

const ModalConfirmLeave = ({ show, onConfirm, onCancel }) => {
  const intl = useIntl()

  return (
    <Modal
      data-mu-test='modal-confirm-leave'
      show={show}
      onClose={onCancel}
      showClose
      closeOnOverlayClick
      size={MODAL_SIZE_SM}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.MessageOverview.ConfirmExitTitle'
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: 'Load.MessageOverview.ConfirmExitDescription'
          })}
        </p>
      </ModalBody>
      <ModalFoot>
        <Button kind='neutral' onClick={onCancel} data-mu-test='button-cancel'>
          {intl.formatMessage({ id: 'Load.MessageOverview.Cancel' })}
        </Button>
        <Button kind='danger' onClick={onConfirm} data-mu-test='button-confirm'>
          {intl.formatMessage({ id: 'Load.MessageOverview.Exit' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalConfirmLeave.propTypes = {
  show: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func
}

export default ModalConfirmLeave
